export default __webpack_public_path__ + "static/media/pc_brand_banner.a59fd61d.png";